import { supabase, isSupabaseConfigured } from './supabaseClient';

function looksLikeUuid(value) {
  return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
}

export async function insertCertificate(record) {
  if (!isSupabaseConfigured()) {
    console.warn('Supabase is not configured. Skipping cloud insert.');
    return { skipped: true };
  }

  if (!supabase) {
    console.error('Supabase client is null despite being configured');
    return { skipped: true, error: 'Supabase client not initialized' };
  }

  console.log('🔵 Starting Supabase certificate insert...');
  console.log('🔵 Raw record received:', record);

  const providedInstitutionId = record.institutionId || record.institution;
  const safeInstitutionId = looksLikeUuid(providedInstitutionId) ? providedInstitutionId : null;
  if (!safeInstitutionId && providedInstitutionId) {
    console.warn('⚠️ Skipping institution_id due to FK/format; keeping name only:', providedInstitutionId);
  }

  // Flatten some nested props for easier querying
  const row = {
    institution_id: safeInstitutionId,
    institution: record.institution || null,
    student_id: record.studentId || null,
    student_name: record.studentName || null,
    roll_number: record.rollNumber || null,
    certificate_type: record.certificateType || null,
    file_name: record.fileName || null,
    file_hash: record.fileHash || null,
    cid: record.cid || null,
    ipfs_url: record.ipfsUrl || null,
    upload_date: record.uploadDate || new Date().toISOString(),
    anchor_tx: record.anchorTx || null,
    anchor_url: record.anchorUrl || null,
    ocr_data: record.ocrData || null,
    marks: record.marks || null,
    program: record.program || null,
    batch: record.batch || null,
    authentication_result: record.authenticationResult || null,
  };

  console.log('🔵 Formatted row for Supabase:', JSON.stringify(row, null, 2));

  try {
    const { data, error } = await supabase
      .from('certificates')
      .insert(row)
      .select()
      .single();

    if (error) {
      console.error('❌ Supabase insert error:', error);
      console.error('❌ Error code:', error.code);
      console.error('❌ Error message:', error.message);
      console.error('❌ Error details:', error.details);
      console.error('❌ Error hint:', error.hint);
      throw error;
    }
    
    console.log('✅ Successfully inserted certificate to Supabase!');
    console.log('✅ Inserted data:', data);
    return data;
  } catch (e) {
    console.error('❌ Exception during Supabase insert:', e);
    throw e;
  }
}


